import {
  Select,
  Option,
  Breadcrumb,
  BreadcrumbItem,
  Tabs,
  TabPane,
  Pagination,
  Dialog,
  Form,
  FormItem,
  Input,
  Button,
  Image
} from 'element-ui'

// 放入数组
let plugins = [
  Select,
  Option,
  Breadcrumb,
  BreadcrumbItem,
  Tabs,
  TabPane,
  Pagination,
  Dialog,
  Form,
  FormItem,
  Input,
  Button,
  Image
]

function getElementUi (app) {
  plugins.forEach(item => {
    return app.use(item)
  })
}

export default getElementUi



// WEBPACK FOOTER //
// ./src/plugins/index.js